export default __webpack_public_path__ + "static/media/thumb_down.b9fa08da.svg";